import * as React from 'react';

import {CTABanner} from 'shells/cta-banner/cta-banner';
// @ts-expect-error - imported from .js/.jsx file
import {TaskIcon} from 'shells/icon/svg/task-icon';

import styles from './banner.module.css';

type Props = {
    width: number;
    onClick: () => void;
};

export function SAStepTemplatesCtaBanner(props: Props) {
    return (
        <div style={{width: props.width}} className={styles['banner-container']}>
            <CTABanner
                icon={TaskIcon}
                title='Create tasks to complete at each stage of your pipeline'
                text='Use tasks to guide your team through the sales process and keep them on track.'
                buttonText='Get started'
                maxWidth={null}
                onPrimaryAction={props.onClick}
            />
        </div>
    );
}
